export const themes = {
  default: {
    token: {
      // Seed Token
      colorPrimary: "#1890ff",
    },
  },
  charcoal: {
    token: {
      // Seed Token
      colorPrimary: "#36454F",
      colorPrimaryBg: '#dde7ed',
    },
  },
  emeraldGreen: {
    token: {
      // Seed Token
      colorPrimary: "#00674F",
      colorPrimaryBg: '#c7e5de',
    },
  },
};
